import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Spline from '../spline.js';

export default class NodeCreateSpiral extends Node
{
	static PLANE_CHOICES =
	[
		{key: 'zy', label: 'Z-Y'},
		{key: 'xy', label: 'X-Y'},
		{key: 'xz', label: 'X-Z'},
	]

	constructor(pParent)
	{
		super(pParent);	

		this.addInput(PARAM_TYPE.FLOAT, 'radius_x', 0.5, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'radius_y', 0.5, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.BOOLEAN, 'circular', true);
		this.addInput(PARAM_TYPE.FLOAT, 'end_radius_percentage', 0.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'center_elevation', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'outer_elevation', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInputsToGroup('Size', ['radius_x', 'radius_y', 'circular', 'end_radius_percentage', 'center_elevation', 'outer_elevation']);

		this.addInput(PARAM_TYPE.FLOAT, 'num_turns', 2, { minValue: 0, maxValue: 5 });
		this.addInput(PARAM_TYPE.BOOLEAN, 'exponential', false);
		this.addInput(PARAM_TYPE.FLOAT, 'exponent_base', Math.E, { minValue: 1, maxValue: 12 });
		this.addInput(PARAM_TYPE.FLOAT, 'roughness', 0.01, { minValue: 0.001, maxValue: 0.2 });
		this.addInputsToGroup('Shape', ['num_turns', 'exponential', 'exponent_base', 'roughness']);

		this.addInput(PARAM_TYPE.DROPDOWN, 'orientation', NodeCreateSpiral.PLANE_CHOICES[2].key, { dropdownOptions: NodeCreateSpiral.PLANE_CHOICES });
		this.addInput(PARAM_TYPE.FLOAT, 'center_x', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'center_y', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'center_z', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInputsToGroup('Position', ['orientation', 'center_x', 'center_y', 'center_z']);

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}
	
	getType()
	{
		return 'createSpiral';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const lastCircResult = this.getLastInputResult('circular');
		if(strInputName == 'radius_y' && lastCircResult)
			return false;

		const lastExpResult = this.getLastInputResult('exponential');
		if(strInputName == 'exponent_base' && !lastExpResult)
			return false;

		return true;
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let fRadiusX = inputValues['radius_x'];
		let fRadiusY = inputValues['radius_y'];
		if(inputValues['circular'])
			fRadiusY = fRadiusX;

		let pSpline = Spline.createSpiral(fRadiusX, fRadiusY, inputValues['num_turns'], inputValues['end_radius_percentage']/100.0, inputValues['roughness'], 
							inputValues['orientation'], inputValues['exponential'], inputValues['exponent_base'], inputValues['center_x'], inputValues['center_y'], inputValues['center_z'],
							inputValues['outer_elevation'], inputValues['center_elevation']);
		return pSpline.saveToObject();
	}
}
